module.exports = __webpack_public_path__ + "img/workspace-onboarding/create-folders-c54e096c47a016fe58009282da2b7722.png";